module.exports = __webpack_public_path__ + "img/app.632b6570.png";